// Libraries
var React = require('react');

// Styles
require('./TicketAvailabilityTier.scss');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

class MembershipItem extends React.Component {
	render() {
		let ctaData = this.props.tier.buttonLink;

		const { url, available } = ctaData;

		if (url !== null && available) {
			ctaData.linkStyle = 'PRIMARY';
		} else {
			ctaData.linkStyle = 'disabled-secondary';
		}

		return (
			<div className="TicketAvailabilityTier">
				{(this.props.tier.availableDate || this.props.tier.buttonLink.url) &&
					<div className="TicketAvailabilityTier__details">
						<div className="TicketAvailabilityTier__title">
							{this.props.tier.tierName}
						</div>
						<div className="TicketAvailabilityTier__cta">				
							{this.props.tier.buttonLink.url ? (
								<CallToAction button={true} {...ctaData} />
							) : (
								<div>{this.props.tier.availableDate}</div>
							)}
						</div>
					</div>
				}
			</div>
		)
	}
}

module.exports = MembershipItem;



// WEBPACK FOOTER //
// ./src/components/Membership/TicketAvailabilityTier.js